import { useState, type ReactNode } from "react"
import { T, useGT } from "gt-next"
import { Input } from "@/components/ui/input"
import Anchor from "@shared-ui/components/Anchor"

// Translated renderings of the fixed success messages callers pass in (unknown text renders as-is).
const SUCCESS_T: Record<string, ReactNode> = {
    "A magic link has been sent to your email!": <T>A magic link has been sent to your email!</T>
}

export const Email = ({
    onSubmit,
    view,
    isLoading,
    successMessage,
    label = "Email",
    defaultValue
}: {
    onSubmit: (email: string) => void
    view: "sign-in" | "sign-up" | "update-email" | "forgot-password"
    isLoading: boolean
    successMessage?: string
    label?: string
    defaultValue?: string
}) => {
    const [email, setEmail] = useState<string>(defaultValue ?? "")

    // Use label if provided, otherwise use view-specific default
    const placeholder = label || (view === "update-email" ? "Enter new email address" : "Email address")
    const gt = useGT()
    const PLACEHOLDER_T: Record<string, string> = { Email: gt("Email"), "Enter new email address": gt("Enter new email address"), "Email address": gt("Email address") }

    return (
        <form
            method="post"
            onSubmit={(event) => {
                event.preventDefault()
                onSubmit(email)
            }}>
            <div className="space-y-3">
                <Input variant="floating" id={`${view}-email`} name="email" type="email" label={PLACEHOLDER_T[placeholder] ?? placeholder} disabled={isLoading} value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" autoFocus required />

                {view === "forgot-password" && (
                    <div className="flex items-center justify-end">
                        <Anchor href="/login" className="text-[13px] font-medium text-gray-500 hover:text-gray-700">
                            <T>Log in instead?</T>
                        </Anchor>
                    </div>
                )}

                <button
                    type="submit"
                    disabled={isLoading}
                    className="inline-flex w-full items-center justify-center rounded-[16px] bg-[#1a1a1a] px-4 py-3.5 text-[15px] font-semibold text-white transition-all duration-200 hover:bg-[#333] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50">
                    {isLoading ? <T>Loading...</T> : <T>Send magic link</T>}
                </button>

                {successMessage && <p className="text-center text-[13px] text-emerald-600">{SUCCESS_T[successMessage] ?? successMessage}</p>}
            </div>
        </form>
    )
}
